module.exports = __webpack_public_path__ + "img/chapter-1-thumb.70aa9ee2.jpg";